/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
// const msalConfig = {
//   auth: {
//     clientId: window.envConfig.azureAdAuthConfig.clientId,
//     authority: window.envConfig.azureAdAuthConfig.authority,
//     redirectUri: window.envConfig.azureAdAuthConfig.redirectUri,
//   },
//   cache: {
//     cacheLocation: 'localStorage', // This configures where your cache will be stored
//     storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//   },
//   system: {
//     loggerOptions: {
//       loggerCallback: (level, message, containsPii) => {
//         if (containsPii) {
//           return
//         }
//         switch (level) {
//           case LogLevel.Error:
//             console.error(message)
//             return
//           case LogLevel.Info:
//             console.info(message)
//             return
//           case LogLevel.Verbose:
//             console.debug(message)
//             return
//           case LogLevel.Warning:
//             console.warn(message)
//             return
//         }
//       },
//     },
//   },
// }

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
// export const loginRequest = {
//   scopes: window.envConfig.azureAdAuthConfig.scopes,
// }

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}

export const getAzureAuthConfig = () => {
  return {
    auth: {
      clientId: window.envConfig.azureAdAuthConfig.clientId,
      authority: window.envConfig.azureAdAuthConfig.authority,
      redirectUri: window.envConfig.azureAdAuthConfig.redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (
            containsPii ||
            (process.env.NODE_ENV &&
              process.env.NODE_ENV !== 'development' &&
              level !== LogLevel.Error)
          ) {
            return
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message)
              return
            case LogLevel.Info:
              console.info(message)
              return
            case LogLevel.Verbose:
              console.debug(message)
              return
            case LogLevel.Warning:
              console.warn(message)
              return
          }
        },
      },
    },
  }
}

export const getLoginRequest = () => {
  return {
    scopes: window.envConfig.azureAdAuthConfig.scopes,
  }
}
